module.exports = __webpack_public_path__ + "7f24f435475cd00a997d0dd8b177532d.svg";